import { render, staticRenderFns } from "./FieldSelector.vue?vue&type=template&id=40b647fc&scoped=true&"
import script from "./FieldSelector.vue?vue&type=script&lang=ts&"
export * from "./FieldSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FieldSelector.vue?vue&type=style&index=0&id=40b647fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b647fc",
  null
  
)

export default component.exports